import { useState, useContext } from 'react';
import { Modal, Header, Form, Segment, Button } from 'semantic-ui-react';
import styled from 'styled-components';
import CardInput from '../../../components/CardInput';
import CenterMessage from '../../../components/CenterMessage';
import AppContext from '../../../context/HeaderContext';
import { postAPI } from '../../../libs/fetchAPI';
import {
	Elements,
	CardElement,
	useStripe,
	useElements,
} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { strip_publishable_key } from '../../../config';

const CustomFormInput = styled.input`
	padding: 13px !important;
`;

const ButtonContainer = styled.div`
	display: flex;
	margin-left: auto;
`;

const ButtonRight = styled.div`
	margin-left: auto;
`;

const stripe_promise = loadStripe(strip_publishable_key);

function UpdatePaymentInfo({ open, handleClose }) {
	return (
		<Modal
			open={open}
			closeIcon
			onClose={handleClose}
			size="mini"
		>
			<Header>Payment Information</Header>

			<Modal.Content>
				<Elements stripe={stripe_promise}>
					<PaymentInfo handleClose={handleClose} />
				</Elements>
			</Modal.Content>
		</Modal>
	);
}

function PaymentInfo({ handleClose }) {
	const { user, updateUser }            = useContext(AppContext);
	const [ saving, setSaving ]           = useState(false);
	const [ name_on_card, setNameOnCard ] = useState();
	const [ errors, setErrors ]           = useState([]);
	const stripe   = useStripe();
	const elements = useElements();

	const handleSaveUpdatePaymentInfo = async (e) => {
		e.preventDefault();
		setSaving(true);
		setErrors([]);

		const card = elements.getElement(CardElement);
		const { error, paymentMethod } = await stripe.createPaymentMethod({
			type : `card`,
			card,
			billing_details : {
				name : name_on_card,
			},
		});

		if(error) {
			setErrors([error.message]);
			setSaving(false);
			return;
		}

		// Create the subscription
		const { subscription } = await postAPI(`/subscriptions`, {
			payment_method : paymentMethod,
			update         : true,
		});

		const { pending_setup_intent } = subscription;

		console.log(subscription, `psi`)

		if(!pending_setup_intent) {
			updateUser({
				...user,
				...{ payment_status : `active` }
			});

			setSaving(false);
			handleClose();

			return;
		}

		// This is for 3D auth
		if(pending_setup_intent.status === `requires_action`) {
			stripe.confirmCardSetup(pending_setup_intent.client_secret).then((result) => {
				if(result.error) {
					setErrors([result.error.message]);
					setSaving(false);
				}
				else {
					updateUser({
						...user,
						...{ payment_status : `active` }
					});

					setSaving(false);
					handleClose();

					return;
				}
			});
		}
		// This is for card invalid/declined
		else if(pending_setup_intent.status === `requires_payment_method`) {
			// Collect new payment
			setErrors([`Invalid payment. Please enter payment again.`]);
			setSaving(false);
		}
	}

	const handleNameOnCardChange = (e) => {
		setNameOnCard(e.target.value);
	}

	return (
		<Form onSubmit={handleSaveUpdatePaymentInfo}>
			<Form.Field>
				<CustomFormInput
					placeholder="Name on card"
					name="name_on_card"
					onChange={handleNameOnCardChange}
				></CustomFormInput>
			</Form.Field>

			<Segment>
				<CardInput />
			</Segment>

			<ButtonContainer>
				<ButtonRight>
					<Button color="red" onClick={handleClose}>Cancel</Button>
					<Button loading={saving} primary>Update</Button>

					{errors.length > 0 &&
						<CenterMessage negative>
							{errors.map((error, i) => <p key={i}>{error}</p>)}
						</CenterMessage>
					}
				</ButtonRight>
			</ButtonContainer>
		</Form>
	);
}

export default UpdatePaymentInfo;
